import { render, staticRenderFns } from "./HTMLElement.vue?vue&type=template&id=58c31874&"
import script from "./HTMLElement.vue?vue&type=script&lang=js&"
export * from "./HTMLElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports